module.exports = __webpack_public_path__ + "img/compounding.4d7763d3.svg";